import BasePlugin from '@uppy/core/lib/BasePlugin.js'

export default class ImageSizePlugin extends BasePlugin {
    constructor (uppy, opts) {
        super(uppy, opts)
        this.id = opts.id || 'ImageSizePlugin'
        this.type = 'example'
        this.prepareUpload = this.prepareUpload.bind(this) //
    }

    async prepareUpload (fileIDs) {


        let image = null;
        const files = fileIDs.map((fileID) => {
            return {
                getSize: () => {
                    const file = this.uppy.getFile(fileID);
                    if (file.type.split('/')[0] !== 'image') {
                        return
                    }
                   let promise =  new Promise((resolve, cancel) => {


                       this.uppy.emit('preprocess-progress', file, {
                           mode: 'indeterminate',
                           message: "Pregatim upload-ul",
                           value: 1
                       })
                       image = new Image();
                       const data = file.data; // is a Blob instance
                       const url = URL.createObjectURL(data)
                       image.src = url;
                       image.onload = () => {
                           URL.revokeObjectURL(url);
                           resolve({ width: image.width, height: image.height });
                       };
                       image.onerror = () => {
                           resolve({});
                       }
                    })

                    return promise.then((size) => {
                        this.uppy.emit('preprocess-complete', file);
                        this.uppy.setFileMeta(fileID, size);
                    })
                }
            }
        })


        for (let i =0; i < files.length; i++) {
            await files[i].getSize();
        }
    }

    install () {
        this.uppy.addPreProcessor(this.prepareUpload.bind(this))
    }

    uninstall () {
        this.uppy.removePreProcessor(this.prepareUpload.bind(this))
    }
}

